import OrganizationListItem from "../OrganizationListItem/OrganizationListItem";

export function OrganizationsList({ organizations }) {
    if (organizations.length === 0) {
        return <p>Нет доступных организаций</p>;
    }

    return organizations.map((organization) => (
        <OrganizationListItem
            key={organization.identifier}
            identifier={organization.identifier}
            name={organization.name}
            type={organization.organizationType}
        />
    ));
}
